export default __webpack_public_path__ + "static/media/Hawai.30929943.jpg";